import {
    LegacyCard,
    DescriptionList,
    Page,
    Layout, SettingToggle, Frame
} from '@shopify/polaris';
import {useEffect} from 'react';
import { useState } from 'react';
import {useParams, useHistory} from 'react-router-dom';
import Api from '../../helpers/api';

const ShowUser = props => {
    const history = useHistory();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const {userId} = useParams();

    useEffect(() => {
        setLoading(true);
        Api
            .getUser(userId)
            .then( response => {
                setUser(response.data.user);
            })
            .finally(() => setLoading(false));
    }, []);

    const toggleAdminPrivileges = () => {
        setLoading(true);
        Api
            .toggleAdminPrivileges(userId)
            .then((response) => {
                setUser(response.data.user);
            })
            .finally(() => setLoading(false));
    }

    const toggleOnHoldPrivileges = () => {
        setLoading(true);
        Api
            .toggleOnHoldPrivileges(userId)
            .then((response) => {
                setUser(response.data.user);
            })
            .finally(() => setLoading(false));
    }

    return user && (
        <Frame>
            <Page title={`User`}
                  backAction={{ content: 'Go back', onAction: () => history.go(-1) }}
            >
                <Layout>
                    <Layout.Section variant="fullWidth">
                        <LegacyCard sectioned>
                            <DescriptionList items={[
                                { term: 'Email', 'description': user.email },
                                { term: 'Name', 'description': user.name },
                            ]} />
                        </LegacyCard>
                    </Layout.Section>

                    <Layout.Section variant="oneHalf">
                        <SettingToggle
                            action={{
                                content: user.is_admin ? "Revoke admin privileges" : "Add admin privileges",
                                onAction: toggleAdminPrivileges,
                                loading: loading
                            }}
                            enabled={user.is_admin}
                        >
                            { user.is_admin ? "User has admin privileges" : "User doesn't have admin privileges"}
                        </SettingToggle>
                    </Layout.Section>
                    <Layout.Section variant="oneHalf">
                        <SettingToggle
                            action={{
                                content: user.can_manage_on_hold ? "Revoke On Hold privileges" : "Add On Hold privileges",
                                onAction: toggleOnHoldPrivileges,
                                loading: loading
                            }}
                            enabled={user.can_manage_on_hold}
                        >
                            { user.can_manage_on_hold ? "User has On Hold privileges" : "User doesn't have On Hold privileges"}
                        </SettingToggle>
                    </Layout.Section>
                </Layout>
            </Page>
        </Frame>
    );
}

export default ShowUser;
